import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    callouts: {
      canceled: {
        description: 'Contact the account holder for more information.',
        title: 'Cancelled transfer',
      },
      pending: {
        description:
          'The transfer is currently being reviewed by the account holder.',
        title: 'Pending approval',
      },
      processing: {
        description:
          'The transfer has been validated by the account holder. It is now being processed, which can take up to 24 hours.',
        title: 'Processing',
      },
    },
  },
  fr: {
    callouts: {
      canceled: {
        description:
          'Contactez le ou la titulaire du compte pour plus d’informations.',
        title: 'Virement annulé',
      },
      pending: {
        description:
          'Le virement est actuellement en train d’être revu par le ou la titulaire du compte.',
        title: 'En attente de validation',
      },
      processing: {
        description:
          'Le virement a bien été validé par le ou la titulaire du compte. Il est maintenant en traitement, ce qui peut prendre jusqu’à 24h.',
        title: 'En cours de traitement',
      },
    },
  },
} as const);

export default locales;
